var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynamodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 289,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5294cf",
    d: "M165.258 288.501h3.508l57.261-28.634.953-1.347V29.964l-.953-1.354L168.766 0h-3.551z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f5b98",
    d: "M90.741 288.501h-3.557l-57.212-28.634-1.161-1.997-.589-226.742 1.75-2.518L87.184 0h3.601z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d72b8",
    d: "M87.285 0h81.426v288.501H87.285z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a476f",
    d: "m256 137.769-1.935-.429-27.628-2.576-.41.204-57.312-2.292h-81.43l-57.313 2.292V91.264l-.06.032.06-.128 57.313-13.28h81.43l57.312 13.28 21.069 11.199v-7.2l8.904-.974-.922-1.798-28.192-20.159-.859.279-57.312-17.759h-81.43L29.972 72.515V28.61L0 63.723v30.666l.232-.168 8.672.946v7.348L0 107.28v30.513l.232-.024 8.672.128v12.807l-7.482.112L0 150.68v30.525l8.904 4.788v7.433l-8.531.942-.373-.28v30.661l29.972 35.118v-43.901l57.313 17.759h81.43l57.481-17.811.764.335 27.821-19.862 1.219-1.979-8.904-.982v-7.284l-1.167-.466-19.043 10.265-.69 1.44-57.481 13.203v.016h-81.43v-.016l-57.313-13.259v-43.864l57.313 2.284v.056h81.43l57.312-2.34 1.305.6 26.779-2.306 1.889-.923-8.904-.128v-12.807z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d72b8",
    d: "M226.027 215.966v43.901L256 224.749v-30.461l-29.8 21.626zM226.027 197.421l.173-.04 29.8-16.028v-30.649l-29.973 2.757zM226.2 91.208l-.173-.04v43.8L256 137.769v-30.634zM226.2 72.687 256 94.193V63.731L226.027 28.61v43.905l.173.06z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamodb);
export default __webpack_public_path__ + "static/media/dynamodb.4cee24f62dd37941e9cd734b65b82c92.svg";
export { ForwardRef as ReactComponent };